import React from 'react';
import * as Sentry from '@sentry/react';
import Logo from '../Logo';

const GlobalFallback = ({ error, resetError }: { error: Error; resetError: () => void }) => {
    return (
        <div className="min-h-screen bg-app-bg flex flex-col items-center justify-center p-6 text-center">
            <div className="w-16 h-16 mb-6">
                <Logo className="w-full h-full" />
            </div>
            <h1 className="text-2xl font-bold text-text-ink mb-2">Something went wrong</h1>
            <p className="text-text-muted mb-6 max-w-md">
                We've been notified about this issue and are looking into it.
                Please try reloading the application.
            </p>

            {/* Dev-only error preview */}
            {import.meta.env.DEV && (
                <div className="mb-6 p-4 bg-status-warn-bg text-status-warn rounded text-left overflow-auto max-w-2xl text-sm font-mono">
                    <p className="font-bold">{error.name}: {error.message}</p>
                </div>
            )}

            <button
                onClick={() => {
                    resetError();
                    window.location.href = '/dashboard'; // Safe fallback route
                }}
                className="px-6 py-2 bg-action text-white rounded-md font-medium hover:bg-action-dark transition-colors"
            >
                Reload Application
            </button>
        </div>
    );
};

export const GlobalErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Sentry.ErrorBoundary fallback={GlobalFallback}>
            {children}
        </Sentry.ErrorBoundary>
    );
};
